import React from 'react';
import useDialogConfig from '../_hooks/useDialogConfig';
import FiltersPartnerDialog from '../../dialogs/filters.partners';
import useDialogRouter from '../_hooks/useDialogRouter';
import usePageRouter from '../_hooks/usePageRouter';

export default function Launcher(props) {
  const config = useDialogConfig();

  const router = config.params.parentDialogId ?
    useDialogRouter(config.params.parentDialogId) :
    usePageRouter();

  return (
    <FiltersPartnerDialog
      router={router}
      onCancel={props.onClose}
    />
  );
};
